/**
 * Vuex
 * https://vuex.vuejs.org/zh/
 */
export default new Vuex.Store({
  state: {
    loading: false
  },
  mutations: {},
  actions: {},
  modules: requires(require.context('./', true, /\.store\.js$/)),
  strict: process.env.NODE_ENV !== 'production',
})
